import { SCard, SCardTitleRow } from './Card.styled'
import { Caption } from 'components/Typography'
import { ReactElement, ReactNode } from 'react'

interface Props {
  icon?: ReactElement | null
  title?: string | null
  children?: ReactNode
  className?: string
}

export const Card = (props: Props) => {
  return (
    <SCard className={props.className}>
      <SCardTitleRow>
        {props.icon}
        <Caption css={{ color: 'var(--c-gray100)', marginLeft: props.icon ? '1rem' : 0 }}>
          {props.title}
        </Caption>
      </SCardTitleRow>
      {props.children}
    </SCard>
  )
}
